// eslint-disable-next-line
import { UserLayout, BasicLayout, BlankLayout } from '@/layouts'
// import { menuList } from '@/api/menu'

const RouterList = [
  {
    path: '/',
    name: 'layout_base',
    component: BasicLayout,
    children: []
  },
  {
    path: '/system_detail',
    name: 'layout_base',
    component: BasicLayout,
    children: [
      {
        path: '/system/dictData',
        hidden: true,
        component: (resolve) => require(['@/views/system/dictData/index'], resolve),
        name: 'SystemdictData',
        meta: {
          title: '字典详情'
        }
      }
    ]
  },
  {
    path: '/goods',
    name: 'layout_base',
    component: BasicLayout,
    children: [
      {
        path: '/goods/GoodsDetail',
        hidden: true,
        component: (resolve) => require(['@/views/ware/goods/GoodsDetail'], resolve),
        name: 'goods_detail',
        meta: {
          title: '商品详情'
        }
      },
      {
        path: '/goods/edit',
        hidden: true,
        component: (resolve) => require(['@/views/ware/goods/Edit'], resolve),
        name: 'goods_edit',
        meta: {
          title: '商品修改'
        }
      }
    ]
  },
  {
    path: '/course',
    name: 'layout_base',
    component: BasicLayout,
    children: [
      {
        path: '/course/Edit',
        hidden: true,
        component: (resolve) => require(['@/views/course/courselist/Edit'], resolve),
        name: 'course_edit',
        meta: {
          title: '课程修改'
        }
      }
    ]
  },
  // {
  //   path: '/videos_detail',
  //   name: 'layout_base',
  //   component: BasicLayout,
  //   children: [
  //     {
  //       path: '/content/videosadd',
  //       hidden: true,
  //       component: (resolve) => require(['@/views/content/videos/Add.vue'], resolve),
  //       name: 'videosadd',
  //       meta: {
  //         title: '视频添加'
  //       }
  //     },
  //     {
  //       path: '/content/videosedit/:videoId(\\d+)',
  //       hidden: true,
  //       component: (resolve) => require(['@/views/content/videos/Edit.vue'], resolve),
  //       name: 'videosedit',
  //       meta: {
  //         title: '视频编辑'
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/article_detail',
  //   name: 'layout_base',
  //   component: BasicLayout,
  //   children: [
  //     {
  //       path: '/content/articleadd',
  //       hidden: true,
  //       component: (resolve) => require(['@/views/content/article/Add.vue'], resolve),
  //       name: 'articleadd',
  //       meta: {
  //         title: '文章添加'
  //       }
  //     },
  //     {
  //       path: '/content/articleedit/:articleId(\\d+)',
  //       hidden: true,
  //       component: (resolve) => require(['@/views/content/article/Edit.vue'], resolve),
  //       name: 'articleedit',
  //       meta: {
  //         title: '文章编辑'
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/answer_detail',
  //   name: 'layout_base',
  //   component: BasicLayout,
  //   children: [
  //     {
  //       path: '/content/answeradd',
  //       hidden: true,
  //       component: (resolve) => require(['@/views/content/answer/Add.vue'], resolve),
  //       name: 'answeradd',
  //       meta: {
  //         title: '回答添加'
  //       }
  //     },
  //     {
  //       path: '/content/answeredit/:answerId(\\d+)',
  //       hidden: true,
  //       component: (resolve) => require(['@/views/content/answer/Edit.vue'], resolve),
  //       name: 'answeredit',
  //       meta: {
  //         title: '回答编辑'
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/question_detail',
  //   name: 'layout_base',
  //   component: BasicLayout,
  //   children: [
  //     {
  //       path: '/content/questionadd',
  //       hidden: true,
  //       component: (resolve) => require(['@/views/content/question/Add.vue'], resolve),
  //       name: 'questionadd',
  //       meta: {
  //         title: '问题添加'
  //       }
  //     },
  //     {
  //       path: '/content/questionedit/:questionId(\\d+)',
  //       hidden: true,
  //       component: (resolve) => require(['@/views/content/question/Edit.vue'], resolve),
  //       name: 'questionedit',
  //       meta: {
  //         title: '问题编辑'
  //       }
  //     }
  //   ]
  // },
  {
    path: '/comment_detail',
    name: 'layout_base',
    component: BasicLayout,
    children: [
      // {
      //   path: '/content/commentadd',
      //   hidden: true,
      //   component: (resolve) => require(['@/views/content/comment/Add.vue'], resolve),
      //   name: 'commentadd',
      //   meta: {
      //     title: '评论添加'
      //   }
      // },
      // {
      //   path: '/content/commentedit/:commentId(\\d+)',
      //   hidden: true,
      //   component: (resolve) => require(['@/views/content/comment/Edit.vue'], resolve),
      //   name: 'commentedit',
      //   meta: {
      //     title: '评论编辑'
      //   }
      // }
    ]
  },
  {
    path: '/specialcolumn_detail',
    name: 'layout_base',
    component: BasicLayout,
    children: [
      {
        path: '/website/specialcolumn/view/:columnId(\\d+)',
        hidden: true,
        component: (resolve) => require(['@/views/website/specialcolumn/View.vue'], resolve),
        name: 'specialcolumn_view',
        meta: {
          title: '专栏查看'
        }
      },
      {
        path: '/website/specialcolumn/add',
        hidden: true,
        component: (resolve) => require(['@/views/website/specialcolumn/Add.vue'], resolve),
        name: 'specialcolumn_add',
        meta: {
          title: '专栏添加'
        }
      },
      {
        path: '/website/specialcolumn/edit/:columnId(\\d+)',
        hidden: true,
        component: (resolve) => require(['@/views/website/specialcolumn/Edit.vue'], resolve),
        name: 'specialcolumn_edit',
        meta: {
          title: '专栏编辑'
        }
      }
    ]
  },
  {
    path: '/house_detail',
    name: 'layout_base',
    component: BasicLayout,
    children: [
      {
        path: '/website/house/view/:id(\\d+)',
        hidden: true,
        component: (resolve) => require(['@/views/website/house/View.vue'], resolve),
        name: 'house_view',
        meta: {
          title: '首页查看'
        }
      },
      {
        path: '/website/house/add',
        hidden: true,
        component: (resolve) => require(['@/views/website/house/Add.vue'], resolve),
        name: 'house_add',
        meta: {
          title: '首页添加'
        }
      },
      {
        path: '/website/house/edit/:id(\\d+)',
        hidden: true,
        component: (resolve) => require(['@/views/website/house/Edit.vue'], resolve),
        name: 'house_edit',
        meta: {
          title: '首页编辑'
        }
      }
    ]
  },
  {
    path: '/settle_detail',
    name: 'layout_base',
    component: BasicLayout,
    children: [
      {
        path: '/store/settle/detail/:id(\\d+)',
        hidden: true,
        component: (resolve) => require(['@/views/store/settle/Detail.vue'], resolve),
        name: 'settle_detail',
        meta: {
          title: '入驻详情'
        }
      },
    ]
  },
  {
    path: '/source_detail',
    name: 'layout_base',
    component: BasicLayout,
    children: [
      {
        path: '/store/source/detail/:id(\\d+)',
        hidden: true,
        component: (resolve) => require(['@/views/store/source/Detail.vue'], resolve),
        name: 'source_detail',
        meta: {
          title: '审核详情'
        }
      }
    ]
  },
  {
    path: '/shops_detail',
    name: 'layout_base',
    component: BasicLayout,
    children: [
      {
        path: '/store/shops/detail/:id(\\d+)',
        hidden: true,
        component: (resolve) => require(['@/views/store/shops/Detail.vue'], resolve),
        name: 'shops_detail',
        meta: {
          title: '店铺详情'
        }
      },
    ]
  },
  {
    path: '/indent_detail',
    name: 'layout_base',
    component: BasicLayout,
    children: [
      {
        path: '/order/indent/detail/:id(\\d+)',
        hidden: true,
        component: (resolve) => require(['@/views/order/indent/Detail.vue'], resolve),
        name: 'indent_detail',
        meta: {
          title: '订单详情'
        }
      },
    ]
  },
  {
    path: '/refund_detail',
    name: 'layout_base',
    component: BasicLayout,
    children: [
      {
        path: '/order/refund/detail/:id(\\d+)',
        hidden: true,
        component: (resolve) => require(['@/views/order/refund/Detail.vue'], resolve),
        name: 'refund_detail',
        meta: {
          title: '退款详情'
        }
      },
    ]
  },
  {
    path: '/comment_detail',
    name: 'layout_base',
    component: BasicLayout,
    children: [
      {
        path: '/order/comment/detail/:id(\\d+)',
        hidden: true,
        component: (resolve) => require(['@/views/order/comment/Detail.vue'], resolve),
        name: 'comment_detail',
        meta: {
          title: '评价详情'
        }
      },
    ]
  },
  {
    path: '/complain_detail',
    name: 'layout_base',
    component: BasicLayout,
    children: [
      {
        path: '/order/complain/detail/:id(\\d+)',
        hidden: true,
        component: (resolve) => require(['@/views/order/complain/Detail.vue'], resolve),
        name: 'complain_detail',
        meta: {
          title: '投诉详情'
        }
      },
    ]
  },
  {
    path: '/customer_detail',
    name: 'layout_base',
    component: BasicLayout,
    children: [
      {
        path: '/client/customer/add',
        hidden: true,
        component: (resolve) => require(['@/views/client/customer/Add.vue'], resolve),
        name: 'customer_add',
        meta: {
          title: '用户添加'
        }
      },
      {
        path: '/client/customer/edit',
        hidden: true,
        component: (resolve) => require(['@/views/client/customer/Edit.vue'], resolve),
        name: 'customer_edit',
        meta: {
          title: '用户编辑'
        }
      },
      {
        path: '/client/customer/pet',
        hidden: true,
        component: (resolve) => require(['@/views/client/customer/Pet.vue'], resolve),
        name: 'customer_pet',
        meta: {
          title: '用户宠物管理'
        }
      },
      {
        path: '/client/customer/watch',
        hidden: true,
        component: (resolve) => require(['@/views/client/customer/Watch.vue'], resolve),
        name: 'customer_watch',
        meta: {
          title: '查看'
        }
      },
      {
        path: '/client/customer/check',
        hidden: true,
        component: (resolve) => require(['@/views/client/customer/Check.vue'], resolve),
        name: 'customer_check',
        meta: {
          title: '审核'
        }
      }
    ]
  },
  {
    path: '/points_detail',
    name: 'layout_base',
    component: BasicLayout,
    children: [
      {
        path: '/integral/points/edit',
        hidden: true,
        component: (resolve) => require(['@/views/integral/points/Edit.vue'], resolve),
        name: 'points_edit',
        meta: {
          title: '收支明细'
        }
      },
    ]
  },
]

export const asyncRouterMap = RouterList



/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/studentmanage',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import('@/views/user/Login'),
        meta: {
          title: '登录'
        }
      },
      {
        path: 'registrations',
        name: 'registrations',
        component: () => import('@/views/user/RegisterUser')
      },
      {
        path: 'register-result',
        name: 'registerResult',
        component: () => import('@/views/user/RegisterResult')
      },
      {
        path: 'recover',
        name: 'recover',
        component: undefined
      }
    ]
  },
  {
    path: '/401',
    hidden: true,
    component: () => import(/* webpackChunkName: "fail" */ '@/views/error/401')
  },
  {
    path: '/404',
    hidden: true,
    component: () => import(/* webpackChunkName: "fail" */ '@/views/error/404')
  }
]
